import { IAPIRoutes } from "../../../../config";

export interface ICoordNote {
  id: number;
  patient_id: number;
  clinic_id: number;
  user_id: number;
  user_name: string;
  user_role_title: string | null;
  note_text: string;
  status: 0 | 1;
  created_at: string;
  updated_at: string;
}

export type ICoordNotesRepository = ReturnType<
  typeof CoordNotesRepositoryFactory
>;

export const CoordNotesRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST, PATCH } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getNotesAPI = async ({
    clinic_id,
    patient_id,
    limit = 50,
    offset = 0,
  }: {
    clinic_id: number;
    patient_id: number;
    limit?: number;
    offset?: number;
  }) => {
    const url = APIRoutes.apiCoordNotes
      .replace("{clinic_id}", clinic_id.toString())
      .replace("{patient_id}", patient_id.toString());

    return GET(
      url,
      { limit: limit.toString(), offset: offset.toString() },
      { Authorization: `Bearer ${await getAuthenticationToken()}` }
    );
  };

  const createNoteAPI = async ({
    clinic_id,
    patient_id,
    note_text,
  }: {
    clinic_id: number;
    patient_id: number;
    note_text: string;
  }) => {
    const url = APIRoutes.apiCoordNotes
      .replace("{clinic_id}", clinic_id.toString())
      .replace("{patient_id}", patient_id.toString());

    return POST(
      url,
      { note_text },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
        "Content-Type": "application/json",
      }
    );
  };

  const patchNoteAPI = async ({
    clinic_id,
    patient_id,
    note_id,
    note_text,
    status,
  }: {
    clinic_id: number;
    patient_id: number;
    note_id: number;
    note_text?: string;
    status?: 0 | 1;
  }) => {
    const url = APIRoutes.apiCoordNote
      .replace("{clinic_id}", clinic_id.toString())
      .replace("{patient_id}", patient_id.toString())
      .replace("{note_id}", note_id.toString());

    const body: Record<string, unknown> = {};
    if (note_text !== undefined) body.note_text = note_text;
    if (status !== undefined) body.status = status;

    return PATCH(url, body, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
      "Content-Type": "application/json",
    });
  };

  return { getNotesAPI, createNoteAPI, patchNoteAPI };
};
